import * as types from '@/store/types'
import Vue from 'vue'
export default {
    secretClientTaskAll(context, payload) {
        context.secretClientTasks = payload
    },
    secretClientVoteAll(context, payload) {
        context.secretClientVotes = payload
    }
}
